import type { BikeEquipment } from "../types/garage";

const NOW = "2026-07-31T10:15:00.000Z";

export const bikes: BikeEquipment[] = [
  {
    id: "bike-ultimate-2022",
    category: "bike",
    lifecycleStatus: "active",
    readinessStatus: "ready",
    archived: false,
    notes: "Primary road setup for threshold and race specificity.",
    createdAtIso: NOW,
    updatedAtIso: NOW,
    nickname: "Ultimate",
    manufacturer: "Canyon",
    model: "Ultimate CF SL 8 Di2",
    year: 2022,
    purchaseDate: "2022-03-10",
    rideProfile: ["road", "race", "trainer"],
    drivetrain: {
      groupset: "Shimano Ultegra Di2 R8100",
      cassette: "11-34",
      chainrings: "52/36",
      chain: "Shimano CN-M8100",
      bottomBracket: "Token T47",
      crankLengthMm: 172.5
    },
    wheels: {
      wheelset: "Zipp 303 Firecrest",
      tireModel: "Continental GP5000 S TR",
      tireWidthMm: 30,
      tubeless: true,
      tirePressureFrontPsi: 56,
      tirePressureRearPsi: 60
    },
    maintenance: {
      chainWaxDate: "2026-07-25",
      chainMileageMiles: 172,
      totalMileageMiles: 9980,
      brakePads: "good",
      rotors: "good",
      di2BatteryPercent: 74,
      tireSealantDate: "2026-07-03",
      lastServiceDate: "2026-06-14",
      nextServiceNote: "Inspect headset before next A-race block."
    }
  },
  {
    id: "bike-grail-2024",
    category: "bike",
    lifecycleStatus: "active",
    readinessStatus: "maintenance-due",
    archived: false,
    notes: "Primary gravel race bike. Rear pad wear trending up.",
    createdAtIso: NOW,
    updatedAtIso: NOW,
    nickname: "Grail",
    manufacturer: "Canyon",
    model: "Grail CF SLX 8",
    year: 2024,
    purchaseDate: "2024-05-02",
    rideProfile: ["gravel", "race"],
    drivetrain: {
      groupset: "SRAM Rival XPLR AXS",
      cassette: "10-44",
      chainrings: "42T",
      chain: "SRAM Flattop",
      bottomBracket: "DUB BB86",
      crankLengthMm: 172.5
    },
    wheels: {
      wheelset: "DT Swiss GRC 1400",
      tireModel: "Schwalbe G-One RS",
      tireWidthMm: 40,
      tubeless: true,
      tirePressureFrontPsi: 34,
      tirePressureRearPsi: 37
    },
    maintenance: {
      chainWaxDate: "2026-07-20",
      chainMileageMiles: 238,
      totalMileageMiles: 3210,
      brakePads: "watch",
      rotors: "watch",
      di2BatteryPercent: 100,
      tireSealantDate: "2026-06-29",
      lastServiceDate: "2026-05-18",
      nextServiceNote: "Replace rear pads before next gravel race."
    }
  }
];
